import { jsPDF } from 'jspdf'
import 'jspdf-autotable'
import utils from '@/mixins/utils.js'
import store from '@/store/store'
import { vue } from '@/main.js'

export async function generatePdf(
  cadastros,
  nomeProfissional,
  total_de_visitas_realizadas,
  data_inicio,
  data_fim
) {
  const titlePdf = 'Relatório atendimentos'
  const descriptionPdf =
    'Atendimentos, procedimentos, vacinas ou visitas realizados nos últimos 90 dias'
  const headersPdf = [
    'DATA',
    'DIA',
    'MANHÃ',
    'TARDE',
    'NOITE',
    'NÃO INFORMADO',
    'TOTAL',
  ]

  const dataPdf = cadastros.map((c) => ({
    dt_atendimento:
      c.dt_registro != null ? utils.methods.formatDate(c.dt_registro) : '',
    dia: c.ds_dia_semana ?? '',
    manha: c.qtd_manha ?? '',
    tarde: c.qtd_tarde ?? '',
    noite: c.qtd_noite ?? '',
    nao_informado: c.qtd_nao_informado ?? '',
    qtd_total: c.qtd_total,
  }))

  const table = dataPdf.map((row) => Object.values(row))
  const doc = new jsPDF(utils.methods.encryptionPdf())

  try {
    const base64Brasao = await utils.methods.fileToBase64(
      store.state.infoMunicipio.brasao
    )
    let verticalPosition = utils.methods.headerPdf(
      doc,
      base64Brasao,
      titlePdf,
      descriptionPdf
    )

    // Informações do profissional
    doc.setFontSize(12)
    doc.text(
      `Profissional: ${nomeProfissional}`,
      15,
      verticalPosition,
      null,
      null,
      'left'
    )
    verticalPosition += 6
    doc.text(
      `Atendimentos realizados: ${total_de_visitas_realizadas}`,
      15,
      verticalPosition,
      null,
      null,
      'left'
    )

    // Período
    verticalPosition += 6
    if (data_inicio && data_fim) {
      const periodo = `Período: ${utils.methods.formatDate(
        data_inicio
      )} até ${utils.methods.formatDate(data_fim)}`
      doc.text(periodo, 15, verticalPosition, null, null, 'left')
      verticalPosition += 5
    }

    doc.autoTable({
      head: [headersPdf],
      body: table,
      headStyles: {
        fillColor: '#ccc',
        fontSize: 6,
        textColor: '#000',
        halign: 'center',
        cellWidth: 'wrap',
      },
      bodyStyles: {
        halign: 'center',
        fontSize: 6,
      },
      theme: 'striped',
      startY: verticalPosition,
      showHead: 'firstPage',
      willDrawCell: ({ row, section }) => {
        if (section === 'head') doc.setTextColor(0, 0, 0)

        let dia = row.raw[1]
        if (dia == 'Sábado' || dia == 'Domingo') {
          doc.setTextColor(194, 10, 16)
        }
      },
    })

    utils.methods.footerPdf(doc, doc.autoTable.previous.finalY)
    doc.save(`${titlePdf}.pdf`)

    vue.$toast.success('PDF GERADO COM SUCESSO!', 'Sucesso:', {
      position: 'topRight',
    })
  } catch (error) {
    console.error(error)
    vue.$toast.error('ERRO AO GERAR PDF!', 'Erro:', { position: 'topRight' })
  }
}

export async function generatePdfDia(cadastros, dia, atendimentos) {
  const titlePdf = 'Relatório atendimentos'
  const descriptionPdf =
    'Atendimentos, procedimentos, vacinas ou visitas realizados nos últimos 90 dias'
  const headersPdf = [
    'Estabelecimento',
    'Cidadão atendido',
    'Nascimento',
    'Data',
    'Hora',
    'Tipo',
  ]

  const dataPdf = cadastros.map((c) => ({
    no_unidade_saude: c.no_unidade_saude ?? '',
    no_cidadao: c.no_cidadao ?? '',
    dt_nascimento:
      c.dt_nascimento != null ? utils.methods.formatDate(c.dt_nascimento) : '',
    dt_atendimento:
      c.dt_atendimento != null
        ? utils.methods.formatDate(c.dt_atendimento)
        : '',
    dt_hour_atendimento: c.dt_hour_atendimento ?? '',
    ds_tipo_atendimento: c.ds_tipo_atendimento,
  }))

  const table = dataPdf.map((row) => Object.values(row))
  const doc = new jsPDF(utils.methods.encryptionPdf())

  try {
    const base64Brasao = await utils.methods.fileToBase64(
      store.state.infoMunicipio.brasao
    )
    let verticalPosition = utils.methods.headerPdf(
      doc,
      base64Brasao,
      titlePdf,
      descriptionPdf
    )

    doc.setFontSize(12)
    doc.text(`Dia: ${dia}`, 15, verticalPosition, null, null, 'left')
    verticalPosition += 6
    doc.text(
      `Atendimentos realizados: ${atendimentos}`,
      15,
      verticalPosition,
      null,
      null,
      'left'
    )

    verticalPosition += 6
    doc.autoTable({
      head: [headersPdf],
      body: table,
      headStyles: {
        fillColor: '#ccc',
        fontSize: 6,
        textColor: '#000',
        halign: 'center',
        cellWidth: 'wrap',
      },
      bodyStyles: {
        halign: 'center',
        fontSize: 6,
      },
      theme: 'striped',
      startY: verticalPosition,
      showHead: 'firstPage',
      willDrawCell: ({ row, section }) => {
        if (section === 'head') doc.setTextColor(0, 0, 0)
      },
    })

    utils.methods.footerPdf(doc, doc.autoTable.previous.finalY)
    doc.save(`${titlePdf}.pdf`)

    vue.$toast.success('PDF GERADO COM SUCESSO!', 'Sucesso:', {
      position: 'topRight',
    })
  } catch (error) {
    console.error(error)
    vue.$toast.error('ERRO AO GERAR PDF!', 'Erro:', { position: 'topRight' })
  }
}
